import { render, staticRenderFns } from "./DelStuDialog.vue?vue&type=template&id=d4d3a19c&scoped=true&"
import script from "./DelStuDialog.vue?vue&type=script&lang=js&"
export * from "./DelStuDialog.vue?vue&type=script&lang=js&"
import style0 from "./DelStuDialog.vue?vue&type=style&index=0&id=d4d3a19c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4d3a19c",
  null
  
)

export default component.exports